import { render, staticRenderFns } from "./componenteproteccion-form.vue?vue&type=template&id=888e33dc&scoped=true"
import script from "./componenteproteccion-form.vue?vue&type=script&lang=js"
export * from "./componenteproteccion-form.vue?vue&type=script&lang=js"
import style0 from "./componenteproteccion-form.vue?vue&type=style&index=0&id=888e33dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "888e33dc",
  null
  
)

export default component.exports